<template>
  <div>
    <div class="d-flex flex-row-reverse justify-content-end align-items-center mb-4">
      <h3 class="mb-0">اضافه کردن فیلتر</h3>
      <i class="fa-duotone fa-filter-list fa-2xl me-2"></i>
    </div>
    <BaseText
        title="نام"
        class="mb-2"
        @input="colName = $event"
        :value="colName"
        inputType="text"
        placeholder="عنوان"
        :maxlength="30"
        :showError="colError"
        :errortext="colErrorText"
        required
      />
      <BaseText
        title="عملیات"
        class="mb-2"
        @input="colName = $event"
        :value="colName"
        inputType="text"
        placeholder="عنوان"
        :maxlength="30"
        :showError="colError"
        :errortext="colErrorText"
        required
      />
  </div>
</template>

<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
export default {
    components:{
        BaseText
    }
}
</script>

<style></style>
